<div class="float-left bg-white card-background padding-15">

  <!-- <accord *ngFor="let data of accordianData" [data]="data" class="panel panel-default" (openEvent)="closeOther($event)" (deleteEvent)="deleteByIndex($event)"></accord>
    <button class="btn btn-primary btn-sm " (click)="add()"><i class="icon btn-cta plus-icon" aria-hidden="true"></i>add another medication</button>  -->
  <!-- <form [formGroup]="testUICtOneForm" autocomplete="off" role="form" class="fieldHeight">
    <app-content-top-nav [visibleBackNav]='true' [enableBackNav]='true'></app-content-top-nav>
    <div class="col-md-12 clear-all title-wrapper">
      <h1 class="title-text custom-header-h2" id="healthAndLifeStyle-header">Testing UI control types</h1>
    </div>

    <div class="row mar-left">

      <ng-container>
        <div class="col-md-12">
          <app-question [childId]="'test1'" [questionConfig]="userInputDetail.radioButtonDependantConfig" [parent]="testUICtOneForm"
            [controlName]="'test1'">
          </app-question>
        </div>
         
        <div class="col-md-12">
          <app-radio-button-dot [labelRadBtn]="'TestRadio'" [optionsListRadBtn]="radioButtonConfig"></app-radio-button-dot>
        </div>  
      </ng-container>
       new input components
               <app-input-box></app-input-box>
               <div class="col-md-12 clear-all margin-top-30 mar-bottom-30">
                <div class="col-md-5 clear-all">
                  <app-input-search  [addressList]="searchDataConfig"></app-input-search>
                </div>
              </div>
       
    </div>


    <div class="col-md-12 clear-all">
      <div class="positioningTabSquare Rectangle_new">
        <app-tab-square-button (medicationEmitter)=getName($event)></app-tab-square-button>
        <div class="hr_line"></div>
        <div>
          <div class="Name-of-medication">
            <span>Name of medication</span>
          </div>
          <div class="form-field-text">
            <input type="text" class="form-control" formControlName="medName">

          </div>
        </div>
        <div>
          <div class="date-input-pos">
            <span>Date prescribed</span>
          </div>
          <div class="form-field-date">
            <input type="text" class="form-control" placeholder="DD / MM / YYYY">
          </div>
        </div>
        <div>
          <div class="Name-of-medication">
            <span>Dose Prescribed</span>
          </div>
          <div class="form-field-text">
            <input type="text" class="form-control" placeholder="Please enter">

          </div>
        </div>
        <div>
          <div class="Name-of-medication">
            <span>Dosage measured in</span>
          </div>
          <div class="form-field-text">
            <select type="text" class="form-control">
              <option>- Please select -</option>
              <option>Kilo grams</option>
              <option>Grams</option>
            </select>

          </div>
        </div>
        <div>
          <div class="Name-of-medication">
            <span>Frequency</span>
          </div>
          <div class="form-field-text">
            <select type="text" class="form-control">
              <option>- Please select -</option>
              <option>Daily</option>
              <option>Weekly</option>
              <option>Monthly</option>
              <option>Yearly</option>
            </select>

          </div>
        </div>
      </div>

    </div>


    
    <div class="col-md-12 clear-all ml-40">
    <ng-container>
    <p class="bd">Checkbox Subquestion Component</p>

    <div class="col-md-12 posComponent">
      <app-checkbox-subquestion [label]="'Have you been diagnosed with any of the following diabetic compications?'"
       [subquestionOptionList]="checkboxSubquestionConfig"></app-checkbox-subquestion>
    </div>
  </ng-container>
  </div>





    <div class="col-md-12 clear-all">
      <div class="float-left">
        <app-save [location]="'contentBottom'"></app-save>
      </div>
      <div class="float-right">
        <app-content-bottom-nav (click)="gotoNextPage()" [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'">
        </app-content-bottom-nav>

      </div>
    </div>
  </form> -->

  
</div>